import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../../../assets/css/customer-loan-reply.css";

export default function CustomerLoanReply() {
  const { token } = useParams();

  const API_BASE = process.env.REACT_APP_API_BASE;

  const [loading, setLoading] = useState(true);
  const [loan, setLoan] = useState(null);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({});
const [submitting, setSubmitting] = useState(false);

const [documents, setDocuments] = useState({});

  useEffect(() => {
    fetch(
      `${API_BASE}/loans/customer_reply.php?token=${token}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setLoan(data.loan);
        } else {
          setError(data.message || "Invalid link");
        }
      })
      .catch(() => {
        setError("Unable to load application");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token, API_BASE]);


  const handleChange = (field, value) => {
  setFormData((prev) => ({
    ...prev,
    [field]: value
  }));
};


const handleDocumentChange = (
  field,
  file
) => {
  setDocuments((prev) => ({
    ...prev,
    [field]: file,
  }));
};

const handleSubmit = async () => {
  try {

    setSubmitting(true);

    const fd = new FormData();

    fd.append("token", token);

    fd.append(
      "updates",
      JSON.stringify(formData)
    );

    Object.entries(documents).forEach(
      ([field, file]) => {

        if (file) {
          fd.append(field, file);
        }

      }
    );

    const response = await fetch(
      `${API_BASE}/loans/customer_reply_submit.php`,
      {
        method: "POST",
        body: fd
      }
    );

    const result = await response.json();

    if (result.success) {

    alert(
  "Your update has been submitted successfully."
);

window.location.href =
  "/customer-reply-success";

    } else {

      alert(
        result.message ||
        "Unable to submit update."
      );

    }

  } catch (error) {

    console.error(error);

    alert(
      "Unable to submit update."
    );

  } finally {

    setSubmitting(false);

  }
};

  if (loading) {
    return (
      <div className="customer-loan-page">
        <div className="customer-loading-card">
          <div className="customer-loader"></div>

          <h2>Loading Application</h2>

          <p>
            Please wait while we securely validate
            your application link.
          </p>
        </div>
      </div>
    );
  }

  if (error || !loan) {
    return (
      <div className="customer-loan-page">
        <div className="customer-error-container">

          <div className="customer-error-icon">
            <i className="bi bi-shield-exclamation"></i>
          </div>

          <h1>Secure Link Validation Failed</h1>

          <p>
            This loan update link is invalid,
            expired or unavailable.
          </p>

          <div className="customer-error-message">
            {error}
          </div>

          <div className="customer-support-card">
            <h4>Need Assistance?</h4>

            <p>
              Please contact your Relationship
              Manager or customer support.
            </p>
          </div>
        </div>
      </div>
    );
  }

  let returnedFields = [];

  let returnedDocuments = [];

try {
  returnedDocuments = loan?.returned_documents
    ? JSON.parse(loan.returned_documents)
    : [];
} catch {
  returnedDocuments = [];
}

  try {
    returnedFields = loan?.returned_fields
      ? JSON.parse(loan.returned_fields)
      : [];
  } catch {
    returnedFields = [];
  }

  return (
    <div className="customer-loan-page">

      <div className="customer-loan-card">

        <div className="customer-header">

          <div className="customer-status-badge">
            Loan Application Update Required
          </div>

          <h1>
            {loan.first_name} {loan.last_name}
          </h1>

          <p>
            Tracking ID: {loan.tracking_id}
          </p>

        </div>

        <div className="customer-summary-grid">

          <div className="summary-card">
            <span>Email Address</span>
            <strong>{loan.email}</strong>
          </div>

          <div className="summary-card">
            <span>Phone Number</span>
            <strong>{loan.phone}</strong>
          </div>

          <div className="summary-card">
            <span>Loan Product</span>
            <strong>{loan.loan_product}</strong>
          </div>

          <div className="summary-card">
            <span>Requested Amount</span>
            <strong>
              ₦{Number(
                loan.loan_amount || 0
              ).toLocaleString()}
            </strong>
          </div>

        </div>

        <div className="customer-alert">

          <div className="alert-header">
            <i className="bi bi-exclamation-circle"></i>

            <h3>
              Additional Information Required
            </h3>
          </div>

          <p>
            Your loan application has been returned
            for review. Kindly provide the requested
            information below so processing can
            continue.
          </p>

          {loan.reviewer_comment && (
            <div className="return-comment">
              <strong>
                Reviewer Comment
              </strong>

              <p>
                {loan.reviewer_comment}
              </p>
            </div>
          )}

        </div>

        <div className="returned-fields-card">

          <div className="section-title">
            <i className="bi bi-pencil-square"></i>

            <h4>
              Fields Requiring Update
            </h4>
          </div>

          <ul className="returned-field-list">
            {returnedFields.map((field) => (
              <li key={field}>
                {field
                  .replaceAll("_", " ")
                  .toUpperCase()}
              </li>
            ))}
          </ul>

        </div>

     <div className="customer-update-form">

  <div className="section-title">
    <i className="bi bi-pencil-square"></i>
    <h4>Update Required Information</h4>
  </div>

  {returnedFields.includes("phone") && (
    <div className="form-group">
      <label>Phone Number</label>
      <input
        type="text"
        defaultValue={loan.phone || ""}
        onChange={(e) =>
          handleChange("phone", e.target.value)
        }
      />
    </div>
  )}

  {returnedFields.includes("email") && (
    <div className="form-group">
      <label>Email Address</label>
      <input
        type="email"
        defaultValue={loan.email || ""}
        onChange={(e) =>
          handleChange("email", e.target.value)
        }
      />
    </div>
  )}

  {returnedFields.includes("bvn") && (
    <div className="form-group">
      <label>BVN</label>
      <input
        type="text"
        defaultValue={loan.bvn || ""}
        onChange={(e) =>
          handleChange("bvn", e.target.value)
        }
      />
    </div>
  )}

  {returnedFields.includes("nin") && (
    <div className="form-group">
      <label>NIN</label>
      <input
        type="text"
        defaultValue={loan.nin || ""}
        onChange={(e) =>
          handleChange("nin", e.target.value)
        }
      />
    </div>
  )}

  {returnedFields.includes("bank_name") && (
    <div className="form-group">
      <label>Bank Name</label>
      <input
        type="text"
        defaultValue={loan.bank_name || ""}
        onChange={(e) =>
          handleChange("bank_name", e.target.value)
        }
      />
    </div>
  )}

  {returnedFields.includes("account_number") && (
    <div className="form-group">
      <label>Account Number</label>
      <input
        type="text"
        defaultValue={loan.account_number || ""}
        onChange={(e) =>
          handleChange(
            "account_number",
            e.target.value
          )
        }
      />
    </div>
  )}

  {returnedFields.includes("loan_amount") && (
    <div className="form-group">
      <label>Loan Amount</label>
      <input
        type="number"
        defaultValue={loan.loan_amount || ""}
        onChange={(e) =>
          handleChange(
            "loan_amount",
            e.target.value
          )
        }
      />
    </div>
  )}

 {returnedDocuments.length > 0 && (
  <>
    <div className="section-title mt-4">
      <i className="bi bi-file-earmark-arrow-up"></i>
      <h4>Upload Returned Documents</h4>
    </div>

    {returnedDocuments.map((doc) => (
      <div className="form-group" key={doc}>
        <label>
          {doc.replaceAll("_", " ").toUpperCase()}
        </label>

        <input
          type="file"
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={(e) =>
            handleDocumentChange(
              doc,
              e.target.files[0]
            )
          }
        />
      </div>
    ))}
  </>
)}


  <div className="form-group">
    <label>Customer Comment</label>
    <textarea
      rows="4"
      placeholder="Provide any additional information..."
      onChange={(e) =>
        handleChange(
          "customer_comment",
          e.target.value
        )
      }
    />
  </div>

  <button
    type="button"
    className="customer-submit-btn"
    disabled={submitting}
    onClick={handleSubmit}
  >
    {submitting
      ? "Submitting..."
      : "Submit Updates"}
  </button>

</div>

      </div>

    </div>
  );
}